export default {"src":"/_next/static/media/favicon.b643f001.ico","height":32,"width":32,"blurWidth":0,"blurHeight":0};